var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaystore0(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 38,
    viewBox: "0 0 33 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8196 18.3148L0.930664 34.4743C0.932062 34.4771 0.932062 34.4814 0.933461 34.4843C1.39074 36.2389 2.95697 37.5303 4.81687 37.5303C5.56083 37.5303 6.25864 37.3243 6.85716 36.964L6.90471 36.9354L23.6633 27.0466L15.8196 18.3148Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8812 15.5631L30.8673 15.5531L23.6318 11.2644L15.4805 18.682L23.6612 27.0449L30.8575 22.7991C32.1188 22.1013 32.9761 20.7413 32.9761 19.174C32.9761 17.6152 32.1314 16.2624 30.8812 15.5631Z",
    fill: "#FBBC04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.930014 3.80425C0.840515 4.14174 0.792969 4.49639 0.792969 4.86248V33.4176C0.792969 33.7837 0.840515 34.1383 0.931412 34.4744L16.3308 18.7282L0.930014 3.80425Z",
    fill: "#4285F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9291 19.1396L23.6344 11.2615L6.89534 1.33705C6.28703 0.963811 5.57663 0.749305 4.81729 0.749305C2.95739 0.749305 1.38837 2.04349 0.931085 3.79958C0.931085 3.80101 0.929688 3.80245 0.929688 3.80388L15.9291 19.1396Z",
    fill: "#34A853"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore0);
export default __webpack_public_path__ + "static/media/playstore0.7c2f94ad3f701e4d5c7eee72e7cfa323.svg";
export { ForwardRef as ReactComponent };